import axios from 'axios'

import config from '../config'

const getAll = () => {
  return axios.get(`${config.baseUrl}/expenses`, {
    headers: {
      'Authorization': `Bearer ${ sessionStorage.getItem('MonteVerdeToken') }`,
    },
  })
}

const getById = id => {
  return axios.get(`${config.baseUrl}/expenses/${id}`, {
    headers: {
      'Authorization': `Bearer ${sessionStorage.getItem('MonteVerdeToken')}`,
    },
  })
}

const getByMonth = monthSelected => {
  return axios.get(`${config.baseUrl}/expenses/month/${monthSelected}`, {
    headers: {
      'Authorization': `Bearer ${sessionStorage.getItem('MonteVerdeToken')}`,
    },
  })
}

const getByFilter = filters => {
  return axios.post(`${config.baseUrl}/expenses/filter/`, filters, {
    headers: {
      'Authorization': `Bearer ${sessionStorage.getItem('MonteVerdeToken')}`,
    },
  })
}

const createExpense = expense => {
  return axios.post(`${config.baseUrl}/expenses`, expense, {
    headers: {
      'Authorization': `Bearer ${sessionStorage.getItem('MonteVerdeToken')}`,
    },
  })
}

const updateExpense = (expenseId, updates) => {
  return axios.put(`${config.baseUrl}/expenses/${expenseId}`, updates, {
    headers: {
      'Authorization': `Bearer ${sessionStorage.getItem('MonteVerdeToken')}`,
    },
  })
}

/*const getUploadAuthorization = (trialId, docType) => {
  return axios.post(`${config.baseUrl}/expenses/getUploadAuthorization`, {
    trialId, docType
  }, {
    headers: {
      'Authorization': `Bearer ${sessionStorage.getItem('MonteVerdeToken')}`,
      'AuthorizationM': `Bearer ${sessionStorage.getItem('MonteVerdeTokenM')}`,
    },
  })
}

const addDocumentMtDB = (doc) => {
  return axios.post(`${config.baseUrl}/expenses/addDocumentMtDB`, doc, {
    headers: {
      'Authorization': `Bearer ${sessionStorage.getItem('MonteVerdeToken')}`,
      'AuthorizationM': `Bearer ${sessionStorage.getItem('MonteVerdeTokenM')}`,
    },
  })
}*/

const getUploadAuthorizationAWS = (fileName, fileType) => {
  return axios.post(`${config.baseUrl}/expenses/getUploadAuthorizationAWS`, {
      fileName, fileType
  }, {
    headers: {
      'Authorization': `Bearer ${sessionStorage.getItem('MonteVerdeToken')}`,
      'AuthorizationM': `Bearer ${sessionStorage.getItem('MonteVerdeTokenM')}`,
    },
  })
}

const getAccessAuthorizationAWS = (fileName) => {
  return axios.post(`${config.baseUrl}/expenses/getAccessAuthorizationAWS`, {
      fileName
  }, {
    headers: {
      'Authorization': `Bearer ${sessionStorage.getItem('MonteVerdeToken')}`,
      'AuthorizationM': `Bearer ${sessionStorage.getItem('MonteVerdeTokenM')}`,
    },
  })
}

const deleteExpense = (id, docId)=> {
  return axios.delete(`${config.baseUrl}/expenses/${id}`, {
    headers: {
      'Authorization': `Bearer ${sessionStorage.getItem('MonteVerdeToken')}`,
      'AuthorizationM': `Bearer ${sessionStorage.getItem('MonteVerdeTokenM')}`
    },
  });
};

const replicateExpense = (id, qtd)=> {
  console.log(qtd);
  return axios.post(`${config.baseUrl}/expenses/replicate/${id}`, qtd, {
    headers: {
      'Authorization': `Bearer ${sessionStorage.getItem('MonteVerdeToken')}`,
      'AuthorizationM': `Bearer ${sessionStorage.getItem('MonteVerdeTokenM')}`
    },
  });
};

const parcellateExpense = (id, qtd)=> {
  console.log(qtd);
  return axios.post(`${config.baseUrl}/expenses/parcellate/${id}`, qtd, {
    headers: {
      'Authorization': `Bearer ${sessionStorage.getItem('MonteVerdeToken')}`,
      'AuthorizationM': `Bearer ${sessionStorage.getItem('MonteVerdeTokenM')}`
    },
  });
};

const attachDocument = (pdfPath, billPath) => {
  return axios.post(`${config.baseUrl}/expenses/attachDocument`, {
    urlOne: pdfPath,
    urlTwo: billPath
  }, {
    headers: {
      'Authorization': `Bearer ${sessionStorage.getItem('MonteVerdeToken')}`,
      'AuthorizationM': `Bearer ${sessionStorage.getItem('MonteVerdeTokenM')}`,
    },
  });
};

const addTrialMtDB = (trial) => {
  return axios.post(`${config.baseUrl}/expenses/addTrialMtDB`, trial, {
    headers: {
      'Authorization': `Bearer ${sessionStorage.getItem('MonteVerdeToken')}`,
      'AuthorizationM': `Bearer ${sessionStorage.getItem('MonteVerdeTokenM')}`,
    },
  })
}

const editTrialMtDB = (info) => {
  return axios.post(`${config.baseUrl}/expenses/move-document-trial`, info, {
    headers: {
      'Authorization': `Bearer ${sessionStorage.getItem('MonteVerdeToken')}`,
      'AuthorizationM': `Bearer ${sessionStorage.getItem('MonteVerdeTokenM')}`,
    },
  })
}

const getTrialMonthByCustomer = (customerId, date) => {
  return axios.get(`${config.baseUrl}/expenses/${date}/customer/${customerId}`, {
    headers: {
      'Authorization': `Bearer ${sessionStorage.getItem('MonteVerdeToken')}`,
      'AuthorizationM': `Bearer ${sessionStorage.getItem('MonteVerdeTokenM')}`,
    },
  })
}

const sendDocToAWS = (url, fileToUpload) => {
  return axios.put(url, fileToUpload, {
    headers: {
      "Content-Type": fileToUpload.type,
    }
  });
};


export default { getAll, getById, createExpense, updateExpense, getByMonth, getByFilter, getTrialMonthByCustomer, getUploadAuthorizationAWS, addTrialMtDB, attachDocument, deleteExpense, replicateExpense, parcellateExpense, editTrialMtDB, sendDocToAWS, getAccessAuthorizationAWS }
